var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['v-spinner', _vm.spinnerSize, _vm.spinnerVariant]},[_vm._v(" ")])}
var staticRenderFns = []

export { render, staticRenderFns }